import awsConfig from '../aws-exports';
import { LicenseEndpointOption } from '../context/licenseEndpointContext';

export interface AvailableEndpoints {
	options: LicenseEndpointOption[];
	hasMultiple: boolean;
	defaultOption: LicenseEndpointOption;
}


/**
 * Determines which license endpoints are available based on environment configuration
 * @returns Object with available options and whether multiple endpoints exist
 */
export const getAvailableEndpoints = (): AvailableEndpoints => {
	const hasArcus = !!awsConfig.arcusLicenseAcquisitionEndpointUrl;
	const hasPlayFactory = !!awsConfig.licenseAcquisitionEndpointUrl;
	
	const options: LicenseEndpointOption[] = [];
	
	// If both are available, add 'auto' option
	if (hasArcus && hasPlayFactory) {
		options.push('auto');
	}
	
	if (hasArcus) {
		options.push('arcus');
	}
	
	if (hasPlayFactory) {
		options.push('playfactory');
	}
	
	// Determine default based on what's available
	let defaultOption: LicenseEndpointOption = 'auto';
	
	if (options.length === 1) {
		// Only one endpoint available, use it directly
		defaultOption = options[0];
	} else if (hasArcus && hasPlayFactory) {
		// Both available, use auto
		defaultOption = 'auto';
	}
	
	return {
		options,
		hasMultiple: options.length > 1,
		defaultOption
	};
};
